import { Provider } from '@angular/core';
import { LOOKUP_HANDLERS } from './lookup-handler';
import { YardStatusLookupHandler } from './handlers/yard-status-lookup';
import { CierreCajaUsuariosLookupHandler } from './handlers/cierre-caja-usuarios-lookup';

export const LOOKUP_HANDLERS_PROVIDERS: Provider[] = [
  { provide: LOOKUP_HANDLERS, useExisting: YardStatusLookupHandler, multi: true },
  { provide: LOOKUP_HANDLERS, useExisting: CierreCajaUsuariosLookupHandler, multi: true },
];
